import fetch from '../fetch';

import {
  CONTENT_LIST,
  CONTENT_SAVE,
  CONTENT_DELETE,
  CONTENT_DETAIL,
  CONTENT_CHANNEL_BIND,
  CONTENT_LABEL_RELATE,
  CONTENT_LABEL_LIST,
  CONTENT_LABEL_SAVE,
  CONTENT_LABEL_DELETE,
} from '../url';

// 获取内容管理列表
function getContentList(data) {
  return fetch({
    url: CONTENT_LIST,
    method: 'post',
    data: data
  });
}

// 新增内容
function saveContentItem(data) {
  return fetch({
    url: CONTENT_SAVE,
    method: 'post',
    data: data
  });
}

// 删除内容
function deleteContentItem(data) {
  return fetch({
    url: CONTENT_DELETE,
    method: 'post',
    data: data
  });
}

// 内容详情
function getContentDetail(data) {
  return fetch({
    url: CONTENT_DETAIL,
    method: 'post',
    data: data
  });
}

// 内容详情
function bindContentChannel(data) {
  return fetch({
    url: CONTENT_CHANNEL_BIND,
    method: 'post',
    data: data
  });
}

// 内容详情-关联标签
function relateContentLabel(data) {
  return fetch({
    url: CONTENT_LABEL_RELATE,
    method: 'post',
    data: data
  });
}

// 标签列表
function getContentLabelList(data) {
  return fetch({
    url: CONTENT_LABEL_LIST,
    method: 'post',
    data: data
  });
}

// 新增/编辑标签
function saveContentLabel(data) {
  return fetch({
    url: CONTENT_LABEL_SAVE,
    method: 'post',
    data: data
  });
}

// 删除标签
function deleteContentLabel(data) {
  return fetch({
    url: CONTENT_LABEL_DELETE,
    method: 'post',
    data: data
  });
}

const contentMgr = {
  getContentList,
  saveContentItem,
  deleteContentItem,
  getContentDetail,
  bindContentChannel,
  relateContentLabel,
  getContentLabelList,
  saveContentLabel,
  deleteContentLabel,
};

export { contentMgr };
